import { AuthLayout } from '@/templates/AuthLayout'
import { LoginForm } from '@/organisms/LoginForm'

export function LoginPage() {
  return (
    <AuthLayout>
      <LoginForm />
    </AuthLayout>
  )
}
